export const campaignKeys = {
  projects: () => ['projects'] as const,
}
